import type { ITreatmentInterviewMachineContext } from './machine/types';
import type { MiniInterviewType } from 'src/packages/polaris/types';
type BuildDxocInterviewOptions = {
  /** Subactor ID of target interview */
  target?: string;
  /** Machine context of treatment interview */
  context?: ITreatmentInterviewMachineContext;
};
export function buildDxocInterview(options: BuildDxocInterviewOptions) {
  const dxoc = options.context?.diagnosis;
  return {
    id: options.target || '',
    question: dxoc?.questionText || '',
    interview: 'dxoc' as MiniInterviewType,
    configs: [
      {
        context: {
          conditionName: dxoc?.name || '',
          slug: dxoc?.slug || '',
          dxocs: dxoc?.predictor ? [dxoc.predictor] : [],
          isInterviewHop: false,
          polarisProps: {
            displayPolarisUI: true,
            showProgressBar: true,
          },
        },
        id: options.target || '',
        interviewType: 'dxoc' as MiniInterviewType,
      },
    ],
  };
}
